import Vue from 'vue'
import Router from 'vue-router'
// import store from '../store/index'
// import STORE_CONST from '../store/consts'

import Dashboard from '@/components/operations/dashboard'
import WorkGroup from '@/components/operations/workgroup'
import WorkGroupDetail from '@/components/operations/workgroup-detail'
import Console from '@/components/console'
import Login from '@/components/login'
import CompelChangePassword from '@/components/compelChangePassword'
import Register from '@/components/register'
import ForgetPsw from '@/components/forgot-password'
import ResetPassword from '@/components/reset-password'
import MfaComfirm from '@/components/mfaComfirm'
import MfaOpen from '@/components/mfaOpen'
import Purchase from '@/components/purchase'
import PrivacyPolicy from '@/components/privacy-policy'
import UserAgreement from '@/components/user-agreement'

import Document from '@/components/operations/document'
import Logs from '@/components/operations/logs'
import Review from '@/components/operations/review'

import SettingWorkgroup from '@/components/settings/workgroup'
import SettingWorkgroupDetail from '@/components/settings/workgroup-detail'
import Cluster from '@/components/settings/cluster'
import ClusterDetail from '@/components/settings/cluster-detail'
import Team from '@/components/settings/team'
import SettingTeamGroupDetail from '@/components/settings/team-group-detail'
import SettingTeamAccountWorkgroup from '@/components/settings/team-account-workgroup'
import SettingTeamGroupWorkgroup from '@/components/settings/team-group-workgroup'

import Statistics from '@/components/system/statistics'
import SystemLog from '@/components/system/system-log'
import AlarmNotify from '@/components/system/alarm-notify'

import AccountInfo from '@/components/personal/account-info'
import AccountSecurity from '@/components/personal/account-security'
import SshKey from '@/components/personal/sshKey'

import ExportOverview from '@/components/overviewExportPdf.vue'
import ExcelLogView from '../components/excel-log-view.vue'

Vue.use(Router)

const router = new Router({
	routes: [
		{
			path: '/',
			name: 'console',
			component: Console,
			children: [
				{
					path: '',
					redirect: '/operation/dashboard',
				},
				{
					path: '/dashboard',
					redirect: '/operation/dashboard',
				},
				{
					path: '/operation',
					name: 'operation',
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: 'dashboard',
							name: 'dashboard',
							component: Dashboard,
							meta: {
								requireLogin: true,
							},
						},
						{
							path: 'workgroup',
							name: 'workgroup',
							component: WorkGroup,
						},
						{
							path: 'workgroup/:id',
							name: 'workgroupdetail',
							component: WorkGroupDetail,
						},
						{
							path: 'document',
							name: 'document',
							component: Document,
						},
						{
							path: 'log',
							name: 'logs',
							component: Logs,
						},
						{
							path: 'review',
							name: 'operation.review',
							component: Review,
						},
					],
				},
				{
					path: '/settings',
					name: 'settings',
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: 'team',
							name: 'team',
							component: Team,
						},
						{
							path: 'cluster',
							name: 'cluster',
							component: Cluster,
						},
						{
							path: 'cluster/:id',
							name: 'clusterDetail',
							component: ClusterDetail,
						},
						{
							path: 'workgroup',
							name: 'settingWorkgroup',
							component: SettingWorkgroup,
						},
						{
							path: 'workgroup/:id',
							name: 'settingWorkgroupDetail',
							component: SettingWorkgroupDetail,
						},
						{
							path: 'group/:id',
							name: 'settingTeamGroupDetail',
							component: SettingTeamGroupDetail,
						},
						{
							path: 'account/:id',
							name: 'settingTeamAccountWorkgroup',
							component: SettingTeamAccountWorkgroup,
						},
						{
							path: 'groupWork/:id',
							name: 'settingTeamGroupWorkgroup',
							component: SettingTeamGroupWorkgroup,
						},
					],
				},
				{
					path: '/system',
					name: 'system',
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: 'statistics',
							name: 'statistics',
							component: Statistics,
						},
						{
							path: 'log',
							name: 'log',
							component: SystemLog,
						},
						{
							path: 'alarmNotify',
							name: 'alarmNotify',
							component: AlarmNotify,
						},
					],
				},
				{
					path: '/personal',
					name: 'personal',
					component: {
						render(c) {
							return c('router-view')
						},
					},
					children: [
						{
							path: 'info',
							name: 'accountInfo',
							component: AccountInfo,
						},
						{
							path: 'security',
							name: 'accountSecurity',
							component: AccountSecurity,
						},
						{
							path: 'sshkey',
							name: 'sshKey',
							component: SshKey,
						},
					],
				},
			],
		},
		{
			path: '/login',
			name: 'login',
			component: Login,
		},
		{
			path: '/compelChangePassword',
			name: 'compelChangePassword',
			component: CompelChangePassword,
		},
		{
			path: '/register',
			name: 'register',
			component: Register,
		},
		{
			path: '/forgetPsw',
			name: 'forgetPsw',
			component: ForgetPsw,
		},
		{
			path: '/mfaComfirm',
			name: 'mfaComfirm',
			component: MfaComfirm,
		},
		{
			path: '/mfaOpen',
			name: 'mfaOpen',
			component: MfaOpen,
		},
		{
			path: '/resetpassword',
			name: 'resetpassword',
			component: ResetPassword,
		},
		{
			path: '/purchase',
			name: 'purchase',
			component: Purchase,
		},
		{
			path: '/privacy-policy',
			name: 'privacyPolicy',
			component: PrivacyPolicy,
		},

		{
			path: '/user-agreement',
			name: 'userAgreement',
			component: UserAgreement,
		},
		{
			path: '/exportOverview',
			name: 'exportOverview',
			component: ExportOverview,
		},
		{
			path: '/excelLogView',
			name: 'excelLogView',
			component: ExcelLogView,
		},
		// { path: '*', redirect: '/' }
	],
})
router.beforeEach((to, from, next) => {
	/*
  if (to.meta.requireLogin) {
    store.dispatch(STORE_CONST.ACCOUNT.CURRENT).then(res => {
      next()
    }).catch(() => {
      next({
        path: '/login',
        query: {redirect: to.fullPath}
      })
    })
  } else {
    next()
  }
  */
	next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js